import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import { useTranslation } from '@/hooks/useTranslation';
import TenantProfileView from '@features/tenant-profile/TenantProfileView';

export const Route = createFileRoute('/t/profile/$id')({
  staticData: { breadcrumb: 'Profile', breadcrumbKey: 'K_BREADCRUMB_PROFILE' },
  component: TenantProfilePage,
});

function TenantProfilePage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const session = useAuthStore((s) => s.session);
  const { t } = useTranslation();

  // Resolve "self" to the tenant's own UUID from session
  const tenantId = id === 'self'
    ? (session?.tenant.id ?? '')
    : id;

  const handleBack = useCallback(() => {
    void navigate({ to: '/t' });
  }, [navigate]);

  if (!tenantId) {
    return (
      <div style={{ padding: '32px', textAlign: 'center', color: '#888' }}>
        {t('K_UNABLE_DETERMINE_TENANT', 'Unable to determine client. Please try again.')}
      </div>
    );
  }

  return (
    <TenantProfileView
      mode={{ kind: 'tenant', tenantId }}
      onBack={handleBack}
    />
  );
}
